import GetStarted from './GetStarted/GetStarted';
import HomepageHero from './Hero/HomepageHero';
import ForumsSection from './Forums';
import EventsSection from './Events';
import LearningSection from './Learning';
import ChampionsSection from './Champions';
import NewsletterSection from './Newsletter/Newsletter';

export {
  GetStarted,
  HomepageHero,
  ForumsSection,
  EventsSection,
  LearningSection,
  ChampionsSection,
  NewsletterSection,
};
